import { type ComponentProps } from 'react'

import { ButtonText } from '@/components/common/Button'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { usePage } from '@/components/providers/PageProvider'
import { BRAND_LABELS } from '@/defs/brand'
import { type PriceSourceType } from '@/defs/price'
import { getBrandSealedLink, getBulkExportLink } from '@/utils/brandUtil'

import { DecklistBuyLinkCardsphere } from './DecklistBuyLinkCardsphere/DecklistBuyLinkCardsphere'
import styles from './DecklistBuyLinks.module.scss'

export type DecklistBuyButtonType = Pick<ComponentProps<typeof ButtonText>, 'colorScheme' | 'fontNormal' | 'hover'>

type Props = {
  decklist: string[]
}

const DECKLIST_PRICE_SOURCES: PriceSourceType[] = ['cardkingdom', 'tcgplayer', 'manapool', 'cardsphere']

export const DecklistBuyLinks = ({ decklist }: Props) => {
  const { page } = usePage()

  const preconLabel = page?.featured?.precon?.label
  const isPrecon = page?.route?.section === 'preconsFeatured' && !!preconLabel

  const buttonProps: DecklistBuyButtonType = {
    colorScheme: 'surface',
    fontNormal: true,
    hover: 'accent',
  }

  return (
    <ul className={styles.container}>
      {DECKLIST_PRICE_SOURCES.map((source, i) => {
        const { icon, label } = BRAND_LABELS[source]
        const isCardsphereExport = source === 'cardsphere' && !isPrecon

        const url = isPrecon
          ? getBrandSealedLink({ brand: source, medium: 'decklist', term: preconLabel })
          : getBulkExportLink({ brand: source, decklist })

        if (!isCardsphereExport && !url) return null

        return (
          <li key={`${i}-${source}`}>
            {isCardsphereExport ? (
              <DecklistBuyLinkCardsphere buttonProps={buttonProps} decklist={decklist} />
            ) : (
              <ButtonText {...buttonProps} as='LinkOutbound' href={url} utm={{ medium: 'decklist' }}>
                <IconWithLabel iconBefore={icon}>{`Buy at ${label}`}</IconWithLabel>
              </ButtonText>
            )}
          </li>
        )
      })}
    </ul>
  )
}
